import React, {useMemo, useState} from 'react';
import {Button, LinearProgress, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import * as XLSX from 'xlsx';



export const AddChartData = ({
    setData,
    handleClose,
    setLine,
    makeLine,
    setMakeLine,
    line
}) => {

    const [loading, setLoading] = useState(false)
    const [chosenFile, setChoseFile] = useState(null)

    const generateKey = useMemo(() => {
        return `График - ${line.length + 2}`
      },[line])
    
    const successUploadAct = (dataStroke, makeLine, setLine) => {
        setData((prev) => { 
            if (prev === null) {
                return dataStroke.map(dot => {
                    return {
                        name: Number(dot[0]),
                        [makeLine.dataKey]: dot[1],
                    }
                })
            } else if (prev.length < dataStroke.length) {
                return dataStroke.map((dot, index) => {
                    if (index < prev.length) {
                        return {
                            ...prev[index],
                            name: Number(dot[0]),
                            [makeLine.dataKey]: dot[1],
                        }
                    } else {
                        return {
                            name: Number(dot[0]),
                            [makeLine.dataKey]: dot[1],
                        }
                    }
                })
            } else {
                return prev.map((dot, index) => {
                    if (index < dataStroke.length) {
                        return {
                            ...dot,
                            name: Number(dataStroke[index][0]),
                            [makeLine.dataKey]: dataStroke[index][1],
                        }
                    }  else {
                        return {
                            ...dot
                        }
                    }
                    
                })
            }   
        })
        setLine((prev) => {
            return [
                ...prev,
                ...[makeLine],
            ]
        })
        setMakeLine( prev => {
            return {
                type: "basis",
                dataKey: generateKey,
                stroke: "#000000",
            }
        })
        handleClose()
    }

    const handleUploadButtonClick = async () => {
        setLoading(true)
        
        const reader = new FileReader();
        reader.onload = (evt) => { 
          
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, {type:'binary'});
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, {header:1});
            const dataHead = data[0]
            const dataRow = [...data]
            dataRow.splice(0, 1)
            
            if (dataRow) {
                successUploadAct(dataRow, makeLine, setLine)
            }
        }
    
        
        reader.readAsBinaryString(chosenFile);   
        setLoading(false)
    }

    const onFileChange = (event) => {
        setChoseFile(event.target.files[0])
    }

    return (
        <div style={{border: '2px solid #000', marginTop: '50px', padding: '10px'}}>
                <Grid container direction={'column'} spacing={2}>
                    <Grid item>
                        <input
                            color="primary"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            onChange={onFileChange}
                            id="icon-button-file-1"
                            style={{display: 'none'}}
                        />
                        <label htmlFor="icon-button-file-1">
                            <Button
                                variant="contained"
                                size="small"
                                component="span"
                                color="primary"
                                disabled={loading}
                            >
                                Выбрать файл
                            </Button>
                        </label>
                    </Grid>
                    <Grid item>
                        <Typography>
                            {chosenFile ? `Выбран файл "${chosenFile.name}"` : 'Выберите файл для загрузки'}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <LinearProgress hidden={!loading}/>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'flex-end'}>
                    <Grid item>
                        <Button onClick={handleUploadButtonClick} disabled={!Boolean(chosenFile)}>
                            Загрузить
                        </Button>
                    </Grid>
                </Grid>
        </div>
    );
};